<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('newTRKRequest.yeniTrElan')"
    />
    <!-- Container-fluid starts-->
    <div class="container">
      <h4 class="mb-3">
        {{ $t('newTRKRequest.yeniTrElan') }}
      </h4>

      <form @submit.prevent="createRequest">
        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newAUCRequest.soruDetallar') }}</h4>
            <hr>

            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newInfoRequest.soruBal') }}</label>
                  <b-form-input
                    id="new_request_title"
                    v-model="requestTitle"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newInfoRequest.sorununBitmTarixi') }}</label>
                  <DatePicker
                    v-model="requestDeadline"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"
                    mode="dateTime"
                    is24hr
                    :minute-increment="15"
                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD HH:mm:ss'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
              </div>
              <div class="col-md-12">
                <div class=" d-flex align-items-center">
                  <div class="checkbox checkbox-success ">
                    <b-form-checkbox
                      v-model="requestIsPrivate"
                      value="1"
                      :disabled="onlyVendors>0"
                    >
                      <div>
                        {{ $t('newAUCRequest.mllifiGizlt') }} <br> <span
                          v-if="requestIsPrivate"
                          class="text-danger"
                        >
                          {{ $t('newAUCRequest.mllifiDigrIstifadilrYalnzMzakiryBalayarsaGrcklr') }}
                        </span>
                        <span
                          v-else
                          class="text-success"
                        >
                          {{ $t('newAUCRequest.mllifiBtnIstifadilrGrcklr') }}
                        </span>
                      </div>
                    </b-form-checkbox>
                  </div>
                </div>


                <div class=" d-flex align-items-center">
                  <div class="checkbox checkbox-success">
                    <b-form-checkbox
                      v-model="requestIsPersonalAllowed"
                      value="1"
                    >
                      {{ $t('newAUCRequest.frdiVensizXslrSorunuCavablayaBilsin') }}
                    </b-form-checkbox>
                  </div>
                </div>



<!--                <div class="d-flex align-items-center">-->
<!--                  <div class="checkbox checkbox-success">-->
<!--                    <b-form-checkbox-->
<!--                      v-model="onlyVerified"-->
<!--                      value="1"-->
<!--                    >-->
<!--                      {{ $t('newAUCRequest.ancaqTsdiqlnmiIrktIstifadilriCavablayaBilsin') }}-->
<!--                    </b-form-checkbox>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>


        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newLogisticRequest.balancMntqVYolaDmTarixi') }}</h4>
            <hr>
            <div class="row">
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.lk') }}</label>
                  <b-form-input
                    v-model="orderExtras.pickUpCountry"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newLogisticRequest.hr') }}</label>
                  <b-form-input
                    v-model="orderExtras.pickUpCity"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.yolaDmTarixi') }}</label>
                  <DatePicker
                    v-model="orderExtras.deadline"
                    mode="date"
                    :locale="$i18n.locale==='az'?undefined: $i18n.locale"

                    :min-date="minDeadline"
                    :is-required="true"
                    :model-config="{type: 'string', mask: 'YYYY-MM-DD'}"
                  >
                    <template #default="{ inputValue, inputEvents }">
                      <input
                        type="text"
                        class="form-control "
                        :value="inputValue"
                        placeholder=""
                        required
                        v-on="inputEvents"
                      >
                    </template>
                  </DatePicker>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newLogisticRequest.sonMntq') }}</h4>
            <hr>

            <div class=" row ">
              <div class="col-sm-6">
                <div class=" mb-3">
                  <label>{{ $t('newLogisticRequest.lk') }}</label>
                  <b-form-input
                    v-model="orderExtras.dropOffCountry"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-sm-6">
                <div class=" mb-3">
                  <label>{{ $t('newLogisticRequest.hr') }}</label>
                  <b-form-input
                    v-model="orderExtras.dropOffCity"
                    type="text"
                    required
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.qeydlr') }}</label>

                  <b-form-textarea
                    v-model="requestDescription"
                    rows="3"
                    required
                  />
                  <span class="text-secondary">{{ $t('newTRKRequest.yolStYkGtrlBilckHrlrinAdnQeydEdBilrsiz') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow">
          <div class="card-body">
            <h4>{{ $t('newTRKRequest.ykHaqqndaMlumatlar') }}</h4>
            <hr>

            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.ykQbulEdckTrnNv') }}</label>

                  <multiselect
                    v-model="orderExtras.truckType"
                    :placeholder="$t('newTRKRequest.trNvnSein')"
                    :label="$t('newTRKRequest.name')"
                    track-by="key"
                    :options="truckTypeList"
                    :multiple="false"
                  >
                    <template
                      slot="singleLabel"
                      slot-scope="props"
                    >
                      <div style="line-height: 1.4; font-size: 12px;">
                        <strong>{{ props.option.name }}</strong> <br>
                        <span style="white-space: pre">{{ props.option.description }}</span>
                      </div>
                    </template>


                    <template
                      slot="option"
                      slot-scope="props"
                    >
                      <div style="line-height: 1.4; font-size: 12px;">
                        <strong>{{ props.option.name }}</strong> <br>
                        <span style="white-space: pre">{{ props.option.description }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.hansNvYklrQbulEdilir') }}</label>

                  <multiselect
                    v-model="orderExtras.types"
                    :placeholder="$t('newTRKRequest.ykNvnSein')"
                    :label="$t('newLogisticRequest.value')"
                    track-by="key"
                    :options="advTypeList"
                    :multiple="true"
                  />
                </div>
              </div>


              <div
                v-if="orderExtras.types.find(t=>t.key==='dangerous')"
                class="col-12"
              >
                <div class="mb-3 ml-2">
                  <div class="checkbox checkbox-success">
                    <b-form-checkbox
                      v-model="orderExtras.driverHasAdr"
                      value="1"
                    >
                      {{ $t('newTRKRequest.srcnnAdrIcazsiVarm') }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.yknMiqdar') }}</label>
                  <b-form-input
                    v-model.number="orderExtras.loadSize"
                    type="number"
                    required
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label>{{ $t('newOfferRequest.lVahidi') }}</label>
                  <select
                    v-model="orderExtras.loadUnit"
                    class="form-control"
                    required
                  >
                    <option
                      v-for="v in loadUnits"
                      :key="v"
                      :value="v"
                    >
                      {{ v }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.danmaQiymti') }}</label>

                  <div class="input-group">
                    <b-form-input
                      v-model.number="orderExtras.priceVolume"
                      type="number"
                      step="0.01"
                      required
                    />
                    <div class="input-group-text">
                      {{ $t('newTRKRequest.n', {expr: orderExtras.loadUnit || '-'}) }}
                    </div>


                    <b-form-input
                      v-model.number="orderExtras.pricePrice"
                      type="number"
                      step="0.01"
                      required
                    />
                    <div class="input-group-text">
                      {{ $t('newAUCRequest.azn') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label>{{ $t('newTRKRequest.qiymtlBalQeydlr') }}</label>

                  <b-form-textarea
                    v-model="orderExtras.priceNotes"
                    rows="3"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="my-5">
          <button class="btn btn-primary">
            <span>{{ $t('newInfoRequest.sorunuYarat') }}</span>
          </button>
        </div>
      </form>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  createRequest, createRequestFromExcel, getVendorManagementStatus,
  getWorkingSectors, upload
} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Datepicker from 'vuejs-datepicker';
import {deliveryTypes, getPhoto, loadTypes, truckTypes} from "@/repositories/Utils";
import moment from "moment";
import Sector_selection_modal from "@/components/sector_selection_modal.vue";
import Sector_path from "@/components/sector_path.vue";
import SelectedSectorView from "@/components/SelectedSectorsView.vue";
import dayjs from "dayjs";


export default {
  components: {
    SelectedSectorView,
    Sector_path,
    Sector_selection_modal,
    Multiselect, Datepicker
  },
  data() {
    return {
      mediaBase: mediaBase,
      requestType: 'TRK',
      requestSubType: '',
      faq: [],
      requestTitle: '',
      requestDescription: '',
      requestIsPrivate: 0,
      requestIsPersonalAllowed: 0,
      onlyVerified: 0,
      onlyVendors: 0,
      requestDeadline: '',
      requestFiles: [],
      requestSectors: [],
      sectors: [],
      uploadProgress: 0,
      products: [],
      photoIndex: 0,
      rfqTerms: 0,
      orderExtras: {
        pickUpCountry: '',
        pickUpCity: '',
        pickUpAddress: '',
        dropOffCountry: '',
        dropOffCity: '',
        dropOffAddress: '',
        deadline: '',
        notes: '',
        incoterms: '',
        types: [],
        loadSize: '',
        loadUnit: '',
        multiSelect: 0,
        ownVariant: 0,


        truckType: '',
        driverHasAdr: 0,
        priceVolume: '',
        pricePrice: '',
        priceNotes: '',

      },
      format: "dd MMM yyyy",
      inctermsList: ["EXW", "FOB", "CIF", "FCA", "DPU", "CFR", "CIP", "DAP", "DDP"],
      typeList: deliveryTypes(),
      advTypeList: loadTypes(),
      productUnits: this.$t("productUnits"),
      serviceUnits: this.$t("serviceUnits"),
      loadUnits: this.$t("loadUnits"),
      pollAnswerList: [],

      vendorManagementAvailable: false
    };
  },
  watch: {

    "$route"() {
      this.requestType = this.$route.query.type;
    },
    onlyVerified(newVal) {
      if (newVal) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.onlyVerifiedModalText"),
          icon: 'warning'
        })
      }
    },
    onlyVendors(newVal) {
      if (newVal) {
        // this.$swal({
        //   title: this.$t("generalModal.warningTitle"),
        //   text: this.$t("newAUCRequest.onlyVendorModalText"),
        //   icon: 'warning'
        // })
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      profile: state => state.auth.profile,
    }),

    minDeadline() {
      return dayjs().add(1, "day").format("YYYY-MM-D");
    },

    truckTypeList() {

      let list = [];

      Object.keys(truckTypes()).forEach((k) => {
        let v = truckTypes()[k];
        v.key = k;

        list.push(v);
      })

      return list;

    },

  },
  mounted() {

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = (code === 200);
    })

  },
  methods: {
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },

    createRequest() {
      let sectors = 13;


      let deadlineFormatted = moment(this.orderExtras.deadline).format('YYYY-MM-DD');

      let extras = {
        "version": "1.0.0",
        "pickupCountry": this.orderExtras.pickUpCountry,
        "pickupCity": this.orderExtras.pickUpCity,
        "dropOffCountry": this.orderExtras.dropOffCountry,
        "dropOffCity": this.orderExtras.dropOffCity,
        "volume": this.orderExtras.loadSize,
        "unit": this.orderExtras.loadUnit,
        "offerDeadline": deadlineFormatted,
        "types": this.orderExtras.types.map((t) => {
          return t.key;
        }).join(","),
        truckType: this.orderExtras.truckType.key,
        driverHasAdr: this.orderExtras.driverHasAdr,
        priceVolume: this.orderExtras.priceVolume,
        pricePrice: this.orderExtras.pricePrice,
        priceNotes: this.orderExtras.priceNotes,
      };

      this.requestSubType = this.requestType;

      if (this.requestTitle !== '' && (sectors + "").length > 0) {

        createRequest(
            this.token,
            this.requestType, this.requestSubType,
            sectors,
            this.requestTitle, this.requestFiles, this.requestDescription,
            this.requestDeadline,
            this.requestIsPrivate, this.requestIsPersonalAllowed,
            this.onlyVerified, this.onlyVendors,
            JSON.stringify(extras),
            this.products, []
        ).then(data => {

          if (data.code === 200) {

            this.$router.replace('/dashboard/request/' + data.id);

          } else {
            this.$swal({
              title: `Error ${data.code}`,
              text: `${data.message}`,
              icon: 'error'
            })
          }

        })

      } else if (sectors.length < 1) {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("generalModal.noWorkingSectorWarning"),
          icon: 'error'
        })
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          text: this.$t("newAUCRequest.butunBolmeleri"),
          icon: 'error'
        })
      }

    },

    getPhoto(path, size) {
      return getPhoto(path, size);
    },


  }

}
</script>
